import type {
    CreateNewsCategoryResponseType,
    CreateNewsCategoryRequestType
} from "./type";
import {
    request
} from "../request";

const CreateNewsCategory = async (params: CreateNewsCategoryRequestType): Promise<CreateNewsCategoryResponseType> => {
    return await request<CreateNewsCategoryResponseType>("/news/createNewsCategory", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateNewsCategory;
